document.addEventListener("DOMContentLoaded", () => {
    const form = document.querySelector("#edit_action_approval_request")
    const decisionInputWrapper = form?.querySelector("li#action_approval_request_decision_input")
    const rejectionReasonInputWrapper = form?.querySelector("li#action_approval_request_rejection_reason_input")
    const rejectionReasonInput = rejectionReasonInputWrapper?.querySelector("textarea#action_approval_request_rejection_reason")

    if (!decisionInputWrapper || !rejectionReasonInputWrapper || !rejectionReasonInput) return

    const HIDDEN = "hidden"
    const DECISION_REJECTION = "rejected"
    const DECISION_CHECKED = 'input[name="action_approval_request[decision]"]:checked'

    const toggleRejectionReasonVisibility = () => {
        const selectedDecision = decisionInputWrapper.querySelector(DECISION_CHECKED)
        if (selectedDecision && selectedDecision.value === DECISION_REJECTION) {
            rejectionReasonInputWrapper.classList.remove(HIDDEN)
            rejectionReasonInput.required = true
        } else {
            rejectionReasonInputWrapper.classList.add(HIDDEN)
            rejectionReasonInput.required = false
        }
    }

    const addEventListeners = () => {
        decisionInputWrapper.addEventListener("change", toggleRejectionReasonVisibility)
    }

    toggleRejectionReasonVisibility()
    addEventListeners()
})
